import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContentWrapper from "../../Components/MainContentWrapper";
import { ROUTES } from "../../routes";
import pilotsCardIcon from "../../assets/pilotsCardIcon.svg";
import { getSubscriptionDetails } from "../../apis/subscription";
import Popup from "../../ReusableFunctions/Popup";
import Loading from "../../ReusableFunctions/Loader";

const Reports = () => {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);

  const reportCards = [
    {
      title: "Pilots Performance",
      icon: pilotsCardIcon,
      description:
        "Performance metrics for each pilot including completed requests, cancelled requests, missed requests, paid requests, total acres completed, and revenue generated.",
      view: ROUTES.PILOTS_PERFORMANCE_REPORT,
    },
  ];
  const orderCards = [
    {
      title: " Spraying Orders",
      icon: pilotsCardIcon,
      description:
        "Report showing individual spray request details including request and service dates, location, pilot and customer information, tank usage, rate, amount, and current status.",
      view: ROUTES.ORDERS_PERFORMANCE_REPORT,
    },
  ];

  const getSubscription = async () => {
    try {
      Loading.set(true);
      const { subscription } = await getSubscriptionDetails();
      return subscription;
    } catch (error) {
      console.log("error", error)
    } finally {
      Loading.set(false);
    }
  };
  return (
    <MainContentWrapper header={"Reports"}>
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
          // gap: "20px",
        }}
      >
        <div
          className="dashboard_cards_wrapper"
          style={{
            display: "flex", // horizontal layout
            flexWrap: "wrap", // wrap to next line if not enough space
            gap: "20px", // space between cards
            // overflow: "auto",
            maxHeight: "70%",
          }}
        >
          {reportCards.map((card, index) => (
            <div
              key={index}
              // onClick={() => card.view && navigate(card.view)}
               onClick={async () => {
                                let subscription = await getSubscription();
                                if ((subscription.plan_name==="Individual Plan")) {
                                 Popup.alert(
    "Upgrade", 
    "Unlock this feature by upgrading to the higher plan.", 
    "UPGRADE", 
    () => {
        navigate("/plan-purchase")  
    }, 
    null, 
    "Upgrade Now"
)
                                } else {
                                   card.view && navigate(card.view)
                                }
                              }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className="admin-dashboard-card"
              style={{
                width: "400px",
                minHeight: "155px",
                height: "162px",
                flexShrink: 0, // prevents shrinking
              }}
            >
              <div className="flex items-center" style={{ gap: "12px" }}>
                {card.icon && (
                  <img
                    src={card.icon}
                    alt={card.title}
                    width={45}
                    height={45}
                  />
                )}
                <span className="text-[#3B3B3B] font-manrope font-[500] custom-md:text-[20px] text-[16px]">
                  {card.title}
                </span>
              </div>

              {card.description && (
                <div
                  style={{
                    marginTop: "16px",
                    fontSize: "14px",
                    color: "#848484",
                    lineHeight: "1.6",
                  }}
                >
                  {card.description}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Orders Wrapper */}
        <div
          className="dashboard_cards_wrapper"
          style={{
            display: "flex",
            gap: "20px",
            // overflow: "auto",
            maxHeight: "70%",
            // marginTop: "20px", // optional spacing between report and order cards
          }}
        >
          {orderCards.map((card, index) => (
            <div
              key={index}
              // onClick={() => card.view && navigate(card.view)}
              onClick={async () => {
                                let subscription = await getSubscription();
                                if ((subscription.plan_name==="Individual Plan")) {
                                   Popup.alert(
    "Upgrade", 
    "Unlock this feature by upgrading to the higher plan.", 
    "UPGRADE", 
    () => {
        navigate("/plan-purchase")  
    }, 
    null, 
    "Upgrade Now"
)
                                } else {
                                   card.view && navigate(card.view)
                                }
                              }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className="admin-dashboard-card"
              style={{
                width: "400px",
                minHeight: "155px",
                height: "162px",
                flexShrink: 0,
              }}
            >
              <div className="flex items-center" style={{ gap: "12px" }}>
                {card.icon && (
                  <img
                    src={card.icon}
                    alt={card.title}
                    width={45}
                    height={45}
                  />
                )}
                <span className="text-[#3B3B3B] font-manrope font-[500] custom-md:text-[20px] text-[16px]">
                  {card.title}
                </span>
              </div>

              {card.description && (
                <div
                  style={{
                    marginTop: "16px",
                    fontSize: "14px",
                    color: "#848484",
                    lineHeight: "1.6",
                  }}
                >
                  {card.description}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </MainContentWrapper>
  );
};

export default Reports;
